import { Suspense, type ReactNode } from 'react'

import { Skeleton, SkeletonBlock } from '@/components/ui/Skeleton'

/**
 * Placeholder mens en kodeopdelt side hentes. Efterligner sidens grove form,
 * så layoutet ikke hopper når indholdet lander.
 */
function RouteFallback() {
  return (
    <SkeletonBlock label="Indlæser side" className="flex flex-col gap-4">
      <Skeleton className="h-8 w-56" />
      <Skeleton className="h-64 w-full rounded-[var(--radius-panel)]" />
    </SkeletonBlock>
  )
}

/** Indpakning af en `React.lazy`-side med ensartet indlæsningstilstand. */
export function Lazy({ children }: { children: ReactNode }) {
  return <Suspense fallback={<RouteFallback />}>{children}</Suspense>
}
